export default __webpack_public_path__ + "static/woman-xs-578e3b867742d35e9d154fa4bbd052ca.webp";